<template>
  <div
    :id="id"
    class="accordion"
  >
    <h3 class="accordion__header">
      <button
        :id="buttonId"
        :aria-controls="panelId"
        :aria-expanded="expanded.toString()"
        class="accordion__toggle"
        type="button"
        @click="toggle"
      >
        <span class="accordion__header-text">
          {{ label }}
        </span>
        <icon
          :icon-name="currentIcon"
          :class="`accordion__header-icon--${currentIcon}`"
          view-box="0 0 21 21"
          class="accordion__header-icon ml-2"/>
      </button>
    </h3>
    <section
      v-show="expanded"
      :id="panelId"
      :aria-labelledby="buttonId"
      class="accordion__panel"
    >
      <div class="accordion__panel-inner mt-md-2 mb-md-5">
        <slot />
      </div>
    </section>
  </div>
</template>

<script>
import Icon from "StyleguideComponents/Icon.vue";
import { CHEVRON_DOWN, CHEVRON_RIGHT } from "Constants/styleguide/iconNames";

export default {
  name: "AccordionRow",
  components: {
    Icon
  },
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      expanded: true
    };
  },
  computed: {
    buttonId() {
      return `${this.id}--toggle`;
    },
    panelId() {
      return `${this.id}--panel`;
    },
    currentIcon() {
      return this.expanded ? CHEVRON_DOWN : CHEVRON_RIGHT;
    }
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded;
    }
  }
};
</script>
